export default __webpack_public_path__ + "static/media/icon-empty-transaction.63b6b1bd.png";